module.exports = __webpack_public_path__ + "images/root/mainVisual_appeal_top_sp_40ee98333f3bffedb42d4e56743ad0cb.svg";